"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LoadingSpikes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LoadingSpikes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0V12a.5.5 0 0 1 .5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.072a.5.5 0 0 1 .183.683l-1.75 3.03a.5.5 0 0 1-.866-.5l1.75-3.03A.5.5 0 0 1 12 1.072Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 11.031a.5.5 0 0 1 .183.683l-1.75 3.031a.5.5 0 0 1-.866-.5l1.75-3.03a.5.5 0 0 1 .683-.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.929 4a.5.5 0 0 1-.183.683l-3.031 1.75a.5.5 0 0 1-.5-.866l3.031-1.75a.5.5 0 0 1 .683.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.968 9.75a.5.5 0 0 1-.183.683l-3.031 1.75a.5.5 0 1 1-.5-.866l3.031-1.75a.5.5 0 0 1 .683.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.032 9.75a.5.5 0 0 1 .683-.183l3.031 1.75a.5.5 0 1 1-.5.866l-3.031-1.75a.5.5 0 0 1-.183-.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.071 4a.5.5 0 0 1 .683-.183l3.031 1.75a.5.5 0 0 1-.5.866l-3.031-1.75A.5.5 0 0 1 1.071 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 11.031a.5.5 0 0 1 .683.183l1.75 3.032a.5.5 0 0 1-.866.5l-1.75-3.032a.5.5 0 0 1 .183-.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.071a.5.5 0 0 1 .683.183l1.75 3.031a.5.5 0 0 1-.866.5l-1.75-3.03A.5.5 0 0 1 4 1.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LoadingSpikes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LoadingSpikes;
exports["default"] = _default;